import React from 'react'
import { Button } from '@/components/ui/button'
import { X, MoreVertical } from 'lucide-react'
import { useRouter } from '@tanstack/react-router'

const Header = () => {
  const router = useRouter()
  
  return (
    <div className="flex items-center justify-between pt-2 px-2">
      <div className="flex items-center gap-1">
        <Button 
          variant="ghost" 
          size="icon" 
          onClick={() => {
            router.navigate({ to: '/branch/purchase-invoices' })
          }}
        >
          <X className="h-4 w-4" />
        </Button>
        <p className='text-sm text-gray-600 ml-2'>Create Purchase Invoice</p>
      </div>
      <Button variant="ghost" size="icon">
        <MoreVertical className="h-4 w-4" />
      </Button>
    </div>
  )
}

export default Header